import { call, put, takeLatest, select, all } from "redux-saga/effects";
import { path, uniqBy, prop, propEq, find } from "ramda";
import { request, authenticatedCall } from "shared/helpers/sagas";
import * as types from "store/scheduler/schedulerTypes";
import API from "store/scheduler/schedulerApis";
import { fetchAvailabilityAndTimeslotsForProject } from "store/scheduler/schedulerActions";
import { isPMOrAdmin } from "shared/helpers/user";
import React from "react";

const snackbarMessage = (
  <span>
    {
      "Moderator availability import is in-progress and will take up to two minutes. If no changes are made,"
    }
    <span
      className="copy-screeners-snackbar-link"
      onClick={() => window.location.reload()}
    >
      {"try refreshing your web page"}
    </span>
    <span>{". You cannot make any changes while the import is ongoing."}</span>
  </span>
);

const formatStartAndEndTimes =
  (options = {}) =>
  (availability) => {
    return Object.assign(
      availability,
      {
        startTime: new Date(availability.startTime),
        endTime: new Date(availability.endTime),
        moderatorId: availability.moderatorId,
      },
      options,
    );
  };

export function* watchFetchAvailabilityForProject({ payload }) {
  yield* authenticatedCall("FETCH_AVAILABILITY_FOR_PROJECT", function* () {
    const availability = yield call(API.fetchAvailabilityForProject, payload);
    yield put({
      type: "FETCH_AVAILABILITY_FOR_PROJECT_SUCCEEDED",
      payload: {
        availability: availability.map(
          formatStartAndEndTimes({ eventType: "availability" }),
        ),
      },
    });
  });
}

export function* watchFetchModeratorAvailability({ payload }) {
  try {
    yield put({ type: "FETCH_MODERATOR_AVAILABILITY" });
    const moderatorId = yield select(path(["user", "userId"]));
    const projectsToFilter = yield select(
      path(["scheduler", "filteredItemsById"]),
    );
    const moderatorsToFilter = yield select(
      path(["scheduler", "filteredModerators"]),
    );
    const projectsToFilterPM = yield select(
      path(["scheduler", "filteredProjects"]),
    );
    const filterBy = yield select(path(["scheduler", "filterBy"]));
    console.log("projectsToFilter ", projectsToFilter);
    const clientId = yield select(path(["client", "clientId"]));
    console.log("payload in watchFetchModeratorAvailability ", payload);
    const [timeSlots, availability] = payload
      ? yield all([
          // if we have a payload, then it's being called from the moderator management page
          call(
            API.fetchTimeSlotsForModerator,
            payload.moderatorId,
            payload.clientId,
            [],
          ),
          call(
            API.fetchModeratorAvailability,
            payload.moderatorId,
            payload.clientId,
          ),
        ])
      : isPMOrAdmin()
        ? yield all([
            call(
              API.fetchTimeSlotsForPM,
              clientId,
              [...projectsToFilterPM],
              [...moderatorsToFilter],
              filterBy,
            ),
            call(
              API.fetchModeratorAvailabilityForPM,
              clientId,
              [...projectsToFilterPM],
              [...moderatorsToFilter],
              filterBy,
            ),
          ])
        : yield all([
            call(API.fetchTimeSlotsForModerator, moderatorId, clientId, [
              ...projectsToFilter,
            ]),
            call(API.fetchModeratorAvailability, moderatorId, clientId),
          ]);
    if (timeSlots.status === 200 && availability.status === 200) {
      console.log(
        "timeslots ",
        timeSlots.data.map(formatStartAndEndTimes({ eventType: "timeSlot" })),
      );
      yield put({
        type: "FETCH_MODERATOR_AVAILABILITY_SUCCEEDED",
        payload: {
          availability: availability.data.map(
            formatStartAndEndTimes({ eventType: "availability" }),
          ),
          timeSlots: timeSlots.data.map(
            formatStartAndEndTimes({ eventType: "timeSlot" }),
          ),
        },
      });
    } else if (timeSlots.status === 405 && availability.status === 405) {
      yield put({ type: "FETCH_MODERATOR_AVAILABILITY_FAILED" });
      yield put({ type: "TOGGLE_IMPORT_MODERATOR_AVAILABILITY_MODAL" });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: snackbarMessage,
          title: "Update In-Progress",
          className: "error-snackbar copy-screeners-snackbar-link",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      // Only show global snackbar when called with a payload (user-initiated context)
      if (payload) {
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message:
              "There was an error processing your request, please try again",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      } else {
        console.log(
          "[Scheduler] Suppressed global error snackbar for availability fetch failure (no payload)",
        );
      }
    }
  } catch (err) {
    console.log("fetch moderators availability failed", err);
    if (err && err.response && err.response.status === 405) {
      yield put({ type: "FETCH_MODERATOR_AVAILABILITY_FAILED" });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: snackbarMessage,
          title: "Update In-Progress",
          className: "error-snackbar copy-screeners-snackbar-link",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      // Only show global snackbar when called with a payload (user-initiated context)
      if (payload) {
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message:
              "There was an error processing your request, please try again",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      } else {
        console.log(
          "[Scheduler] Suppressed global error snackbar for availability fetch error (no payload)",
        );
      }
    }
  }
}

export function* watchUpdateGoogleSpreadSheet() {
  try {
    const updateGoogleSpreadSheet = yield call(API.updateGoogleSpreadSheet);
    console.log("response", updateGoogleSpreadSheet);
    if (updateGoogleSpreadSheet.status === 200) {
      yield put({ type: "UPDATE_GOOGLE_SPREAD_SHEET_SUCCEEDED" });
    } else {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  } catch (err) {
    console.log("update google spread sheet failed", err);
    yield put({
      type: "SHOW_MESSAGE",
      payload: {
        message: "There was an error processing your request, please try again",
        className: "copy-screeners-snackbar",
      },
    });
    yield put({ type: "HIDE_MESSAGE" });
    yield put({ type: "UPDATE_GOOGLE_SPREAD_SHEET_FAILED" });
  }
}

export function* watchUnlinkModeratorCalendar({ payload: payload }) {
  try {
    yield put({ type: "TOGGLE_UNLINK_MODERATOR_AVAILABILITY_MODAL" });
    yield put({ type: "START_UNLINK_IMP_MOD" });
    const result = yield call(
      API.unlinkImportModerator,
      payload.moderatorId,
      payload.clientId,
    );
    if (result.status === 200 && result.data) {
      yield put({ type: "FINISH_UNLINK_IMP_MOD" });
      yield put({
        type: "FETCH_IMPORT_AVAILABILITY_STATUS_SUCCEEDED",
        payload: {
          importAvStatus: "",
          isCalendarExportedBefore: false,
          external_calendar: "",
          external_calendar_key: "",
          modifiedOn: "",
          canNotRunImport: false,
        },
      });
      const singleModerator = yield select(
        path(["scheduler", "singleModerator"]),
      );
      console.log("singleModerator ", singleModerator);
      isPMOrAdmin()
        ? yield put({
            type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED",
            payload: {
              moderatorId: singleModerator.id,
              clientId: singleModerator.clientId,
              isModeratorManagement: true,
            },
          })
        : yield put({ type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED" });
      //if (result.data.Result.statusResult && result.data.Result.statusResult[0].status === "Completed" ) {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            'The moderator’s external availability has been successfully removed. If you like to add a new external availability link you may do so from  "Import Moderator Availability" button. ',
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
      // }
    }
  } catch (e) {
    console.log("fetch import availability status failed", e);
    yield put({ type: "FINISH_UNLINK_IMP_MOD" });
    yield put({
      type: "SHOW_MESSAGE",
      payload: {
        message: "There was an error processing your request, please try again",
        className: "copy-screeners-snackbar",
      },
    });
    yield put({ type: "HIDE_MESSAGE" });
  }
}

export function* watchStartFetchImporetdModeratorAvailability({ payload }) {
  try {
    const clientId = yield select(path(["client", "clientId"]));
    console.log(
      "payload in watchStartFetchImporetdModeratorAvailability ",
      payload,
    );
    const response = yield call(
      API.fetchModeratorImportedAvailability,
      payload.moderatorId,
      clientId,
      payload.externalCalendar,
      payload.key,
      payload.userId,
      payload.forceUpdate,
    );
    if (response.status === 200) {
      console.log("response ", response.data);
      yield put({ type: "START_FETCH_IMPORTED_MOD_AV_SUCCEEDED" });
      if (payload.forceUpdate !== true)
        yield put({ type: "TOGGLE_IMPORT_MODERATOR_AVAILABILITY_MODAL" });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: "Import Moderator Calendar Started...",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  } catch (err) {
    console.log(
      "watch start fetch Imporetd Moderator Availability failed",
      err,
    );
    yield put({ type: "START_FETCH_IMPORTED_MOD_AV_FAILED" });
    if (err && err.response && err.response.status === 409) {
      yield put({
        type: "SET_CALENDAR_URL_ALREADY_USED_ERROR",
        payload: {
          moderatorName: err.response.data.moderatorName,
          value: true,
        },
      });
    }
    if (err && err.response && err.response.status === 405) {
      yield put({ type: "TOGGLE_IMPORT_MODERATOR_AVAILABILITY_MODAL" });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: snackbarMessage,
          title: "Update In-Progress",
          className: "error-snackbar copy-screeners-snackbar-link",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  }
}

export function* watchfetchImportAvailabilityStatus({ payload: payload }) {
  try {
    const result = yield call(
      API.fetchImportAvailabilityStatus,
      payload.moderatorId,
    );
    const previousStatus = yield select(path(["scheduler", "importAvStatus"]));
    if (result.status === 200 && result.data) {
      yield put({
        type: "FETCH_IMPORT_AVAILABILITY_STATUS_SUCCEEDED",
        payload: {
          importAvStatus: result.data.Result.statusResult[0]
            ? result.data.Result.statusResult[0].status
            : "",
          isCalendarExportedBefore: result.data.Result.statusResult[0]
            ? true
            : false,
          external_calendar: result.data.Result.statusResult[0]
            ? result.data.Result.statusResult[0].external_calendar
            : "",
          external_calendar_key: result.data.Result.statusResult[0]
            ? result.data.Result.statusResult[0].external_calendar_key
            : "",
          modifiedOn: result.data.Result.statusResult[0]
            ? result.data.Result.statusResult[0].modified_on
            : "",
          canNotRunImport: result.data.Result
            ? result.data.Result.canNotRunImport
            : "",
        },
      });
      // Guard against empty statusResult array to avoid TypeError
      const hasStatusResult =
        result &&
        result.data &&
        result.data.Result &&
        Array.isArray(result.data.Result.statusResult) &&
        result.data.Result.statusResult.length > 0;
      const currentStatus = hasStatusResult
        ? result.data.Result.statusResult[0].status
        : "";
      if (
        hasStatusResult &&
        currentStatus === "Completed" &&
        previousStatus &&
        previousStatus.length > 0 &&
        previousStatus !== currentStatus
      ) {
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message:
              "The moderator’s availability has been imported successfully. ",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      }
    }
  } catch (e) {
    console.log("fetch import availability status failed", e);
    yield put({ type: "FETCH_IMPORT_AVAILABILITY_STATUS_FAILED" });
  }
}

export function* watchPostModeratorAvailability({ payload }) {
  try {
    yield put({ type: "POST_MODERATOR_AVAILABILITY" });
    // payload.selectedModerator will be defined when called from moderator management page
    const moderatorId = isPMOrAdmin()
      ? payload.selectedModerator.id
      : yield select(path(["user", "userId"]));
    const clientId = isPMOrAdmin()
      ? payload.selectedModerator.clientId
      : yield select(path(["client", "clientId"]));
    console.log("client id ", clientId);
    const availability = yield call(API.postModeratorAvailability, {
      payload,
      clientId,
      moderatorId,
    });
    if (availability.status === 200) {
      yield put({
        type: "POST_MODERATOR_AVAILABILITY_SUCCEEDED",
        payload: {
          availability: availability.data.map(
            formatStartAndEndTimes({ eventType: "availability" }),
          ),
          moderatorId: availability.data[0].moderatorId,
        },
      });
    }
  } catch (err) {
    console.log(
      "post moderators availability failed",
      err ? err : "no error sent from the BE!",
    );
    yield put({ type: "POST_MODERATOR_AVAILABILITY_FAILED" });
    if (err && err.response && err.response.status === 405) {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: snackbarMessage,
          title: "Update In-Progress",
          className: "error-snackbar copy-screeners-snackbar-link",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "This availability conflicts with an existing timeslot or some other condition",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  }
}

export function* watchPutModeratorAvailability({ payload }) {
  yield* authenticatedCall("PUT_MODERATOR_AVAILABILITY", function* () {
    const availability = yield call(API.putModeratorAvailability, payload);
    yield put({
      type: "PUT_MODERATOR_AVAILABILITY_SUCCEEDED",
      payload: {
        availability: availability.data.map(
          formatStartAndEndTimes({ eventType: "availability" }),
        ),
        moderatorId: availability[0].data.moderatorId,
      },
    });
  });
}

export function* watchDeleteModeratorAvailability({ payload: availabilityId }) {
  try {
    yield put("DELETE_MODERATOR_AVAILABILITY");
    const response = yield call(
      API.deleteModeratorAvailability,
      availabilityId,
    );
    if (response.status === 200) {
      yield put({
        type: "DELETE_MODERATOR_AVAILABILITY_SUCCEEDED",
        payload: { availabilityId },
      });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: "Availability has been deleted.",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  } catch (err) {
    console.log("delete moderator availability failed", err);
    if (err && err.response && err.response.status === 404) {
      yield put({
        type: "DELETE_MODERATOR_AVAILABILITY_SUCCEEDED",
        payload: { availabilityId },
      });
      const singleModerator = yield select(
        path(["scheduler", "singleModerator"]),
      );
      console.log("singleModerator ", singleModerator);
      isPMOrAdmin()
        ? yield put({
            type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED",
            payload: {
              moderatorId: singleModerator.id,
              clientId: singleModerator.clientId,
              isModeratorManagement: true,
            },
          })
        : yield put({ type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED" });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: "Availability has been already deleted",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else if (err && err.response && err.response.status === 405) {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: snackbarMessage,
          title: "Update In-Progress",
          className: "error-snackbar copy-screeners-snackbar-link",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
          className: "copy-screeners-snackbar",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  }
}
export function* watchFetchModeratorsForTimeSlot({ payload }) {
  try {
    if (payload) {
      yield put({
        type: "FETCHING_MODERATORS",
      });
      const timeSlotId = payload.timeSlotId ? payload.timeSlotId : payload.id;
      console.log(
        "[Saga.watchFetchModeratorsForTimeSlot] payload:",
        payload,
        "computed timeSlotId:",
        timeSlotId,
      );
      const moderatorTimeSlotsApiResult = yield call(
        API.fetchModeratorsForTimeSlot,
        timeSlotId,
      );
      console.log(
        "[Saga.watchFetchModeratorsForTimeSlot] response status:",
        moderatorTimeSlotsApiResult && moderatorTimeSlotsApiResult.status,
      );
      const moderatorTimeSlots = moderatorTimeSlotsApiResult.data;
      if (moderatorTimeSlotsApiResult.status === 200) {
        yield put({
          type: "FETCH_MODERATORS_FOR_TIME_SLOT_SUCCEEDED",
          payload: { moderatorTimeSlots },
        });
        yield put({
          type: "FETCH_POSSIBLE_MODERATORS_FOR_TIME_SLOT_REQUESTED",
        });
      } else {
        console.log(
          "[Saga.watchFetchModeratorsForTimeSlot] non-200 response:",
          moderatorTimeSlotsApiResult,
        );
        // Suppress global snackbar during modal-open fetches
        if (!payload.fetchAll) {
          yield put({
            type: "SHOW_MESSAGE",
            payload: {
              message:
                "There was an error processing your request, please try again",
            },
          });
          yield put({ type: "HIDE_MESSAGE" });
        } else {
          console.log(
            "[Scheduler] Suppressed global error snackbar (modal open fetchAll)",
          );
        }
      }
    } else {
      yield put({
        type: "TOGGLE_TIMESLOT_MODAL_FROM_SCHEDULER_SUCCEEDED",
      });
    }
  } catch (err) {
    console.log("fetch moderators by timeslot id failed", err);
    // Suppress global snackbar during modal-open fetches
    if (!payload || !payload.fetchAll) {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      console.log(
        "[Scheduler] Suppressed global error snackbar in catch (modal open fetchAll)",
      );
    }
    // Ensure modal spinner stops on failure
    yield put({ type: "TOGGLE_TIMESLOT_MODAL_FROM_SCHEDULER_SUCCEEDED" });
  }
}

export function* watchOpenTimeslotModalFromScheduler({ payload }) {
  try {
    const timeSlotModalOpen = yield select(
      path(["scheduler", "timeSlotModalOpen"]),
    );
    const warningModalOpen = yield select(
      path(["scheduler", "warningModalOpen"]),
    );
    console.log("[Saga.watchOpenTimeslotModalFromScheduler] state:", {
      timeSlotModalOpen,
      warningModalOpen,
      payload,
    });
    if (timeSlotModalOpen || warningModalOpen) {
      if (payload && payload.fetchAll) {
        console.log(
          "[Saga.watchOpenTimeslotModalFromScheduler] fetchAll true; calling watchFetchModeratorsForTimeSlot with id:",
          payload.timeSlotId,
        );
        yield watchFetchModeratorsForTimeSlot({
          payload: { id: payload.timeSlotId },
        });
      }
    }
  } catch (err) {
    console.log("watch open timseslot modal from scheduler failed", err);
    // Suppress global snackbar during modal open flow
    if (!payload || !payload.fetchAll) {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      console.log(
        "[Scheduler] Suppressed global error snackbar in watchOpenTimeslotModalFromScheduler catch (fetchAll)",
      );
    }
  }
}

export function* watchFetchPossibleModeratorsForTimeSlot() {
  try {
    const timeSlotId = yield select(path(["scheduler", "selectedSlotId"]));
    if (timeSlotId) {
      const getPossibleModerators = yield call(
        API.fetchPossibleModeratorsForTimeSlot,
        timeSlotId,
      );
      const possibleModerators = getPossibleModerators.data;
      if (getPossibleModerators.status === 200) {
        yield put({
          type: "FETCH_POSSIBLE_MODERATORS_FOR_TIME_SLOT_SUCCEEDED",
          payload: {
            possibleModeratorsById: possibleModerators.reduce(
              (moderatorsById, currentModerator) => ({
                ...moderatorsById,
                [currentModerator.moderator.id]: {
                  ...currentModerator,
                  value: {
                    isHost: currentModerator.isHost,
                    moderatorId: currentModerator.moderator.id,
                    hasConflict: currentModerator.hasConflict,
                    timeSlotId,
                  },
                  label: `${currentModerator.moderator.firstName} ${currentModerator.moderator.lastName}`,
                },
              }),
              {},
            ),
          },
        });
      }
    } else {
      // Suppress global snackbar when timeslot id is missing during modal open
      console.log(
        "[Scheduler] Suppressed global error snackbar: selectedSlotId missing during possible moderators fetch",
      );
    }
  } catch (err) {
    console.log("fetch possible moderators for timeslot id failed", err);
    // Suppress global snackbar during modal open sequence
    console.log(
      "[Scheduler] Suppressed global error snackbar in catch for possible moderators fetch",
    );
  }
}

export function* watchFetchConferenceLinkByTimeslotId(payload) {
  try {
    const conferenceLinkByTimeslotId = yield call(
      API.fetchConferenceLinkByTimeslotId,
      payload,
    );
    const data = conferenceLinkByTimeslotId.data;
    if (conferenceLinkByTimeslotId.status === 200) {
      yield put({
        type: "FETCH_CONFERENCE_LINK_BY_TIMESLOT_SUCCEEDED",
        payload: data,
      });
    } else {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message:
            "There was an error processing your request, please try again",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    }
  } catch (err) {
    console.log("fetch conference link by timeslot id failed", err);
    yield put({
      type: "SHOW_MESSAGE",
      payload: {
        message: "There was an error processing your request, please try again",
      },
    });
    yield put({ type: "HIDE_MESSAGE" });
  }
}

export function* watchPostModeratorsForConference({ payload }) {
  yield* authenticatedCall("POST_MODERATOR_FOR_CONFERENCE", function* () {
    const timeSlotId = yield select(path(["scheduler", "selectedSlotId"]));
    const timeSlotModalOpen = yield select(
      path(["scheduler", "timeSlotModalOpen"]),
    );
    if (timeSlotModalOpen) {
      const moderatorTimeSlots = yield call(
        API.postModeratorsForConference,
        timeSlotId,
        payload.value,
      );
      yield put({
        type: "POST_MODERATOR_FOR_CONFERENCE_SUCCEEDED",
        payload: moderatorTimeSlots,
      });
    }
  });
}

export function* watchDeleteModeratorsFromConference({ payload }) {
  yield* authenticatedCall("DELETE_MODERATOR_FROM_CONFERENCE", function* () {
    const timeSlotId = yield select(path(["scheduler", "selectedSlotId"]));
    const timeSlotModalOpen = yield select(
      path(["scheduler", "timeSlotModalOpen"]),
    );
    if (timeSlotModalOpen) {
      const moderatorTimeSlots = yield call(
        API.deleteModeratorFromConference,
        timeSlotId,
        payload,
      );
      yield put({
        type: "DELETE_MODERATOR_FROM_CONFERENCE_SUCCEEDED",
        payload: moderatorTimeSlots,
      });
    }
  });
}

export function* watchPutUpdatedTimeslotInfo({ payload }) {
  yield* authenticatedCall("PUT_UPDATED_TIMESLOT_INFO", function* () {
    const timeSlotId = yield select(path(["scheduler", "selectedSlotId"]));
    const pendingIdsForDeletion = yield select(
      path(["scheduler", "pendingModeratorIdsToDelete"]),
    );
    const pendingIdsForAddition = yield select(
      path(["scheduler", "pendingModeratorIdToAdd"]),
    );
    const possibleModeratorsById = yield select(
      path(["scheduler", "possibleModeratorsById"]),
    );
    const pendingModeratorsToAdd = pendingIdsForAddition.map(
      (mid) => possibleModeratorsById[mid].value,
    );

    // TODO once we can accept an array of moderators on POST to API
    //    yield postModeratorsForConference(timeSlotId, pendingModeratorsToAdd)
    const modsAfterAdd = yield pendingModeratorsToAdd.map((mod) =>
      API.postModeratorsForConference(timeSlotId, mod),
    );
    const modsAfterDelete = yield pendingIdsForDeletion.map((id) =>
      API.deleteModeratorFromConference(timeSlotId, id),
    );
    const moderatorTimeSlots = uniqBy(prop("moderatorId"), [
      ...modsAfterDelete,
      ...modsAfterAdd,
    ]);

    //  yield call(API.putObservers, payload, timeSlotId)

    if (payload.forAdmin) {
      yield put(fetchAvailabilityAndTimeslotsForProject(payload.projectId));
    } else yield put({ type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED" });

    yield put({
      type: "PUT_UPDATED_TIMESLOT_INFO_SUCCEEDED",
      payload: { moderatorTimeSlots },
    });

    if (payload.onSave) {
      yield payload.onSave();
    }

    yield put({
      type: "SHOW_MESSAGE",
      payload: { message: "Your changes have been saved." },
    });
  });
}

/**
 * NOTE: This is pretty weird and should probably be refactored.
 * TOGGLE_TIMESLOT_MODAL occasionally doesn't send a payload because it expects
 * that information to already have been placed in state by TOGGLE_TIMESLOT_POPOVER.
 * This is really error-prone - see ICI-491
 * Action shouls provide all the necessary context for their consumers when possible,
 * or at least not have different behaviors that are closely coupled other actions / consumers.
 */

export function* watchFetchAvailabilityAndTimeslotsForProject({ payload }) {
  yield* authenticatedCall(
    "FETCH_AVAILABILITY_AND_TIMESLOTS_FOR_PROJECT",
    function* () {
      const moderatorsToFilter = yield select(
        path(["scheduler", "filteredItemsById"]),
      );
      if (payload) {
        const availabilityAndTimeslots = yield call(
          API.fetchAvailabilityAndTimeslotsForProject,
          payload,
          [...moderatorsToFilter],
        );
        yield put({
          type: "FETCH_AVAILABILITY_AND_TIME_SLOTS_SUCCEEDED",
          payload: {
            availability: availabilityAndTimeslots.availability.map(
              formatStartAndEndTimes({ eventType: "availability" }),
            ),
            timeSlots: availabilityAndTimeslots.timeSlots.map(
              formatStartAndEndTimes({
                eventType: "timeSlot",
                findModerator: (id) =>
                  find(
                    propEq("timeSlotId", id),
                    availabilityAndTimeslots.moderatorTimeSlots,
                  ),
              }),
            ),
            moderatorTimeSlots: availabilityAndTimeslots.moderatorTimeSlots,
          },
        });
      }
    },
  );
}

export default function* watchModeratorSaga() {
  yield takeLatest(
    types.FETCH_MODERATOR_AVAILABILITY_REQUESTED,
    watchFetchModeratorAvailability,
  );
  yield takeLatest(
    types.FETCH_IMPORT_AVAILABILITY_STATUS_REQUESTED,
    watchfetchImportAvailabilityStatus,
  );
  yield takeLatest(
    types.POST_MODERATOR_AVAILABILITY_REQUESTED,
    watchPostModeratorAvailability,
  );
  yield takeLatest(
    types.PUT_MODERATOR_AVAILABILITY_REQUESTED,
    watchPutModeratorAvailability,
  );
  yield takeLatest(
    types.DELETE_MODERATOR_AVAILABILITY_REQUESTED,
    watchDeleteModeratorAvailability,
  );
  yield takeLatest(
    types.FETCH_POSSIBLE_MODERATORS_FOR_TIME_SLOT_REQUESTED,
    watchFetchPossibleModeratorsForTimeSlot,
  );
  yield takeLatest(
    types.TOGGLE_TIMESLOT_MODAL,
    watchOpenTimeslotModalFromScheduler,
  );
  yield takeLatest(
    types.TOGGLE_TIMESLOT_POPOVER,
    watchFetchModeratorsForTimeSlot,
  );
  yield takeLatest(
    types.PUT_UPDATED_TIMESLOT_INFO_REQUESTED,
    watchPutUpdatedTimeslotInfo,
  );
  yield takeLatest(
    types.FETCH_AVAILABILITY_AND_TIMESLOTS_FOR_PROJECT_REQUESTED,
    watchFetchAvailabilityAndTimeslotsForProject,
  );
  yield takeLatest(
    types.FETCH_AVAILABILITY_FOR_PROJECT_REQUESTED,
    watchFetchAvailabilityForProject,
  );
  yield takeLatest(
    types.FETCH_CONFERENCE_LINK_BY_TIMESLOT_REQUESTED,
    watchFetchConferenceLinkByTimeslotId,
  );
  yield takeLatest(
    types.START_FETCH_IMPORTED_MOD_AV_REQUESTED,
    watchStartFetchImporetdModeratorAvailability,
  );
  yield takeLatest(
    types.UNLINK_MODERATOR_CALENDAR,
    watchUnlinkModeratorCalendar,
  );
  yield takeLatest(
    types.UPDATE_GOOGLE_SPREAD_SHEET,
    watchUpdateGoogleSpreadSheet,
  );
}
